<template>
	<div>
		<Modal 
            :loading="loading" 
            title="TOURS DO USUÁRIO"
            @close="close"
            @save="save"
        >
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<h4>Áreas</h4>
				</div>
				<div class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Home" label="Início" icon="fa-home" tooltip="Selecione para definir a exibição do tutorial na seção inícial do sistema" />
				</div>
				<div v-if="has_permission('Customer')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Customer" label="Clientes" icon="fa-building" tooltip="Selecione para definir a exibição do tutorial na seção de clientes" />
				</div>
				<div v-if="has_permission('DistributionCenter') && $api.user.company_routing" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.DistributionCenter" label="Centros Distribuição" icon="fa-pallet" tooltip="Selecione para definir a exibição do tutorial na seção de centros de distribuição" />
				</div>

				<div v-if="has_permission('Driver')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Driver" label="Motoristas" icon="fa-address-card" tooltip="Selecione para definir a exibição do tutorial na seção de motoristas" />
				</div>

				<div v-if="has_permission('Vehicle') && $api.user.company_routing" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Vehicle" label="Veículos" icon="fa-truck" tooltip="Selecione para definir a exibição do tutorial na seção de veículos" />
				</div>

				<div v-if="has_permission('Delivery')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Delivery" label="Entregas" icon="fa-boxes" tooltip="Selecione para definir a exibição do tutorial na seção de entregas" />
				</div>

				<div v-if="has_permission('DeliveryRouting') && $api.user.company_routing" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.DeliveryRouting" label="Roteirizações" icon="fa-route" tooltip="Selecione para definir a exibição do tutorial na seção de roteirização" />
				</div>

				<div v-if="has_permission('Tracking')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Tracking" label="Rastreio" icon="fa-map-marked-alt" tooltip="Selecione para definir a exibição do tutorial na seção de rastreio" />
				</div>
				
				<div v-if="has_permission('Report')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Report" label="Relatório" icon=" fa-file-invoice" tooltip="Selecione para definir a exibição do tutorial na seção de relatório" />
				</div>

				<div v-if="has_permission('Config')" class="col-xs-12 col-lg-6">
					<FormCheckbox v-model="tours.Config" label="Configuração" icon="fa-cog" @input="checkPermissionsConfig" tooltip="Selecione para definir a exibição do tutorial na seção de configuração" />
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormCheckbox from "@/components/FormCheckbox";

export default {
	name: "ConfigUsersTours",

	props: {
        current: {
            type: Object,
            require: true,
        },
    },

	components: {
        Modal,
        FormCheckbox,
    },

	data: function() {
		let perm = [];
        if (this.current.is_admin) perm = ["Home", "Config", "Customer", "Delivery", "DeliveryRouting", "DistributionCenter", "Driver", "Report", "Tracking", "Vehicle"];
        else perm = this.current.permissions.split(",");

        let tour = [];
        if (this.current.tour != null) tour = this.current.tour.split(",");

		return {
			loading: false,
			permissions: {
				Home: perm.includes("Home") ? 1 : 0,
				Config: perm.includes("Config") ? 1 : 0,
				Customer: perm.includes("Customer") ? 1 : 0,
				Delivery: perm.includes("Delivery") ? 1 : 0,
				DeliveryRouting: perm.includes("DeliveryRouting") ? 1 : 0,
                DistributionCenter: perm.includes("DistributionCenter") ? 1 : 0,
				Driver: perm.includes("Driver") ? 1 : 0,
				Report: perm.includes("Report") ? 1 : 0,
				Tracking: perm.includes("Tracking") ? 1 : 0,
				Vehicle: perm.includes("Vehicle") ? 1 : 0,
				User: perm.includes("User") ? 1 : 0,
				Invoice: perm.includes("Invoice") ? 1 : 0,
			},
			tours: {
				Home: tour.includes("Home") ? 1 : 0,
				Config: tour.includes("Config") ? 1 : 0,
				Customer: tour.includes("Customer") ? 1 : 0,
				Delivery: tour.includes("Delivery") ? 1 : 0,
				DistributionCenter: tour.includes("DistributionCenter") ? 1 : 0,
				Driver: tour.includes("Driver") ? 1 : 0,
				DeliveryRouting: tour.includes("DeliveryRouting") ? 1 : 0,
				Report: tour.includes("Report") ? 1 : 0,
				Tracking: tour.includes("Tracking") ? 1 : 0,
				Vehicle: tour.includes("Vehicle") ? 1 : 0,
				User: tour.includes("User") ? 1 : 0,
				Invoice: tour.includes("Invoice") ? 1 : 0,
			}
		};
	},

	methods: {
		has_permission: function(route) {
			if (this.$api.user.is_admin) return true;
			if (this.$api.user.permissions.includes(route)) return true;
			return false;
		},

		save: async function() {
			let t = [];
			
			for (let key in this.tours) {
				if (this.tours[key]) t.push(key);
			}

            let form = {
                id: this.current.id,
                tour: t.join(','),
            };

			this.loading = true;
			let result = null;
			try {
				result = await Api.post("user/update-tour", form);
			} catch(ex) {
				console.log(ex);
				this.$notifications.error("Não foi possível salvar a alteração.");
				return;
			}
			this.loading = false;

			if (result != null) {
				if (result.error) {
					this.$notifications.error(result.data);
					return;
				} else {
                    this.$api.user.tour = t.join(',');
					this.$notification.success(result.data);
					this.$parent.load();
					this.close();
					return;
				}
			} else {
				this.$notifications.error("Não foi possível salvar a alteração.");
				return;
			}
		},

		close: function() {
			this.$emit("close");
		},

		checkPermissionsConfig: function(event) {
			if (!event) {
				this.permissions.Invoice = 0;
				this.permissions.User = 0;
			}
		},

		checkPermissionsUser: function(event) {
			if (event) {
				this.permissions.Config = 1;
			}
		},

		checkPermissionsInvoice: function(event) {
			if (event) {
				this.permissions.Config = 1;
			}
		},
	}
}
</script>

<style scoped>
	
</style>